import React, { useState, useEffect } from "react";
import {
  GeneralContainer,
  ContentContainer,
  AddIcon,
} from "./SOSSettingsContainer.styled";
import SOSUserSettings from "../../components/SOSUsersSettings/SOSUsersSettings";
import SOSNotification from "../../components/SOSNotification/SOSNotification";
import {
  COUNTRIES_BY_CLIENT,
  GET_INSTANT_MESSAGES,
  ICE_CONTACT_BY_CITY,
  ICE_NOTIFICATION_TEMPLATE,
  USERS_IN_ROLE2,
} from "../../GraphQL/Queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import { NotificationManager } from "react-notifications";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { clientWellness } from "../../App";
import {
  CREATE_INSTANT_MESSAGE,
  DELETE_INSTANT_MESSAGE,
  UPDATE_EMAIL_TEMPLATE,
  UPDATE_ICE_CONTACT_FOR_CITY,
  UPDATE_INSTANT_MESSAGE,
} from "../../GraphQL/Mutations";
import { theme as themeConfig } from "../../themes/themes";
import AddCircle from "@material-ui/icons/AddCircle";
import SOSInstantMessages from "../../components/SOSInstantMessages/SOSInstantMessages";
import { IconButton, Tooltip } from "@mui/material";
import CreateInstantMessages from "../../components/CreateInstantMessages/CreateInstantMessages";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import { ROLES } from "../../util/RolesConstants";

const SOSSettingsContainer = () => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [cities, setCities] = useState([]);
  const user = getStateLoginComplete();
  const clientId = user?.clientId;
  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [body, setBody] = useState("");
  const [subject, setSubject] = useState("");
  const [emailTmeplate, setEmailTemplate] = useState();
  const [createInstantMsg, setCreateInstantMsg] = useState(false);
  const [messages, setMessages] = useState([]);
  const [renderAgain, setRenderAgain] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState();
  const [updateUserForCity] = useMutation(UPDATE_ICE_CONTACT_FOR_CITY, {
    client: clientWellness,
  });
  const [updateEmailTemplate] = useMutation(UPDATE_EMAIL_TEMPLATE, {
    client: clientWellness,
  });
  const [createInstantMessage] = useMutation(CREATE_INSTANT_MESSAGE, {
    client: clientWellness,
  });
  const [updateInstantMessage] = useMutation(UPDATE_INSTANT_MESSAGE, {
    client: clientWellness,
  });
  const [deleteMessage] = useMutation(DELETE_INSTANT_MESSAGE, {
    client: clientWellness,
  });
  const [runQueryCountryByClient] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data?.countryLocationList?.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setCountries(resultOfAllCountries);
    },
  });

  const [runQueryUsersInRole2] = useLazyQuery(USERS_IN_ROLE2, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersInRole2 = data.userListAdvancedSearch.map((element) => {
        return {
          value: element?.userId,
          label:
            element?.userFirstName +
            " " +
            element?.userLastName +
            " - " +
            element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
        };
      });
      setUsersList(usersInRole2);
    },
  });

  const [runQueryICEContactByCity] = useLazyQuery(ICE_CONTACT_BY_CITY, {
    fetchPolicy: "network-only",
    client: clientWellness,
    onCompleted: (data) => {
      let usersArr = data?.iceContactByCity.map((element) => {
        return {
          value: element?.userId,
          label: element?.firstName + " " + element?.lastName,
          firstName: element?.firstName,
          lastName: element?.lastName,
        };
      });
      setSelectedUsers(usersArr);
    },
  });

  const [runQueryNotificationTemplate] = useLazyQuery(
    ICE_NOTIFICATION_TEMPLATE,
    {
      fetchPolicy: "network-only",
      client: clientWellness,
      onCompleted: (data) => {
        setSubject(data?.emailTemplateById?.emailSubject);
        setBody(data?.emailTemplateById?.emailBody);
        setEmailTemplate(data?.emailTemplateById);
      },
    }
  );

  const [runQueryGetInstantMessages] = useLazyQuery(GET_INSTANT_MESSAGES, {
    fetchPolicy: "network-only",
    client: clientWellness,
    onCompleted: (data) => {
      const instantMessages = data?.instantMessages.map((im) => ({ ...im }));
      if (instantMessages) {
        setMessages(instantMessages);
      }
    },
  });

  const saveUsers = () => {
    updateUserForCity({
      variables: {
        cityId: selectedCity,
        userIds: selectedUsers.map((e) => parseInt(e.value)),
      },
    })
      .then((res) => {
        if (res?.data?.updateIceContactByCity) {
          NotificationManager.success("Changes saved successfully");
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  const handleChangeSelectCountries = (item) => {
    if (item) {
      setSelectedCity();
      setSelectedUsers([]);
      setSelectedCountry(item.value);
      getCityForCountry(item.value);
    }
  };

  const getCityForCountry = (id) => {
    let selectedCountry = countries.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  const handleChangeSelectCity = (item) => {
    if (item) {
      setSelectedCity(item.value);
      setSelectedUsers([]);
      runQueryICEContactByCity({
        variables: {
          idCity: item.value,
        },
      });
    }
  };

  const handleChangeSelectUsers = (item) => {
    if (item.length > 0) {
      setSelectedUsers(item);
    }
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this message?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={handleDeleteInstantMessage}
      />
    ) : null;
  };

  const saveTemplate = (subject, bodyContent) => {
    updateEmailTemplate({
      variables: {
        idEmailTemplate: emailTmeplate?.idEmailTemplate,
        name: emailTmeplate?.name,
        description: emailTmeplate?.description,
        emailSubject: subject,
        emailBody: bodyContent,
        allCountries: true,
      },
    })
      .then((res) => {
        if (res?.data?.updateEmailTemplate?.idEmailTemplate) {
          NotificationManager.success("Changes saved successfully");
        } else {
          NotificationManager.error("Something went wrong in saving template");
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  useEffect(() => {
    let rolesId = [
      ROLES.SUPER_ADMIN,
      ROLES.GAM,
      ROLES.COUNTRY_ADMIN,
      ROLES.WELLNESS_PROFESSIONAL,
    ];
    runQueryUsersInRole2({
      variables: { rolesId: rolesId },
      context: { clientName: "LinkUsers" },
    });
    runQueryNotificationTemplate();
    runQueryGetInstantMessages();
    if (clientId) {
      runQueryCountryByClient({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, []);

  useEffect(() => {
    runQueryGetInstantMessages();
  }, [renderAgain]);

  const handleSave = (message) => {
    if (message.trim() !== "") {
      if (selectedMessage) {
        handlUpdateMessage(message);
      } else {
        handleCreateInstantMessage(message);
      }
    } else {
      NotificationManager.warning("Please enter a message");
    }
  };

  const handlUpdateMessage = (message) => {
    updateInstantMessage({
      variables: {
        instantMessageId: selectedMessage?.instanceMessageId,
        message,
      },
    })
      .then((res) => {
        if (res?.data?.updateInstantMessage?.instanceMessageId) {
          NotificationManager.success("Updated instant message");
          setCreateInstantMsg(false);
          setRenderAgain(!renderAgain);
        } else {
          NotificationManager.error(
            "Something went wrong in updating instant message"
          );
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  const handleCreateInstantMessage = (message) => {
    createInstantMessage({
      variables: { message },
    })
      .then((res) => {
        if (res?.data?.createInstantMessage?.instanceMessageId) {
          NotificationManager.success("Added a new instant message");
          setCreateInstantMsg(false);
          setRenderAgain(!renderAgain);
        } else {
          NotificationManager.error(
            "Something went wrong in adding instant message"
          );
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  const handleEditInstantMessage = (record) => {
    setCreateInstantMsg(true);
    setSelectedMessage(record);
  };

  const handleDeleteInstantMessage = (record) => {
    deleteMessage({
      variables: {
        instantMessageId: record?.instanceMessageId,
      },
    })
      .then((res) => {
        if (res?.data?.deleteInstantMessage?.instanceMessageId) {
          NotificationManager.success("Deleted message successfully");
          setRenderAgain(!renderAgain);
          setOpenDeleteModal();
        } else {
          NotificationManager.error(
            "Something went wrong in deleting instant message"
          );
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  return (
    <GeneralContainer>
      <div style={{ paddingTop: "1rem", paddingLeft: "1.5rem" }}>
        <label className="header-label">Quick Assist Settings</label>
      </div>
      <hr style={{ marginLeft: "1.5rem", width: "96.5%" }} />
      <ContentContainer>
        <SOSUserSettings
          countries={countries}
          handleChangeSelectCountry={handleChangeSelectCountries}
          cities={cities}
          handleChangeSelectCity={handleChangeSelectCity}
          usersList={usersList}
          selectedCountry={selectedCountry}
          selectedCity={selectedCity}
          selectedUsers={selectedUsers}
          handleChangeSelectUser={handleChangeSelectUsers}
          saveUsers={saveUsers}
        />
        <hr />
      </ContentContainer>
      <ContentContainer>
        <div style={{ paddingTop: "1rem" }}>
          <label className="header-label">Notifications template</label>
        </div>
        <SOSNotification
          body={body}
          setBody={setBody}
          subject={subject}
          saveTemplate={saveTemplate}
        />
        <hr />
      </ContentContainer>
      <ContentContainer>
        <div className="header-icon">
          <label className="header-label">Instant messages</label>
          <AddIcon>
            <Tooltip title="Add">
              <IconButton
                onClick={() => {
                  setSelectedMessage();
                  setCreateInstantMsg(true);
                }}
              >
                <AddCircle style={{ color: themeConfig.text.primary }} />
              </IconButton>
            </Tooltip>
          </AddIcon>
        </div>
        {createInstantMsg && (
          <CreateInstantMessages
            close={setCreateInstantMsg}
            save={handleSave}
            editData={selectedMessage}
          />
        )}
        <SOSInstantMessages
          messages={messages}
          handleEdit={handleEditInstantMessage}
          handleDelete={setOpenDeleteModal}
        />
      </ContentContainer>
      {showDeleteModal()}
    </GeneralContainer>
  );
};

export default SOSSettingsContainer;
